export const INICIO_JORNADA = 'INICIO_JORNADA';
export const INICIO_INTERVALO = 'INICIO_INTERVALO';
export const FIM_INTERVALO = 'FIM_INTERVALO';
export const FIM_JORNADA = 'FIM_JORNADA';

export const JORNADA_ITEM_TIPOS = [
  {
    tipo: INICIO_JORNADA,
    timeField: 'inicioJornada',
    label: 'Inicio Jornada',
  },
  {
    tipo: INICIO_INTERVALO,
    timeField: 'inicioIntervalo',
    label: 'Inicio Intervalo',
  },
  {
    tipo: FIM_INTERVALO,
    timeField: 'finalIntervalo',
    label: 'Final Intervalo',
  },
  {
    tipo: FIM_JORNADA,
    timeField: 'finalJornada',
    label: 'Final Jornada',
  },
];
